import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const MetaHelmet = ({ intl: { formatMessage }, title }) => {
  return <Helmet title={formatMessage({ id: title })} />;
};

MetaHelmet.propTypes = {
  intl: PropTypes.object,
  title: PropTypes.string,
};

export default injectIntl(MetaHelmet);



// WEBPACK FOOTER //
// ./src/components/AppHelmet/MetaHelmet.jsx